module.exports = __webpack_public_path__ + "img/iso-13485.8380048.webp";